import { getBffClient } from '../client/http';

export const sendSlackMessage = async (channel: string, text: string) => {
  try {
    await getBffClient().post(
      `/api/slack/send-message?channel=${channel}&text=${text}`,
    );
  } catch (err: any) {
    throw new Error(`Error sending Slack message: ${err.message}`);
  }
};
